import { render } from "./maintenance.vue?vue&type=template&id=63f52e7a&ts=true"
import script from "./maintenance.vue?vue&type=script&lang=ts"
export * from "./maintenance.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__